// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3IMTN","title":"Images90_title__1gLiF","images":"Images90_images__3sHAv"};